import { useContext } from 'react';
import { NavigationContext } from './NavigationStore';

export const useNavigation = () => useContext(NavigationContext);
